import React from 'react';
import { useTranslation } from 'react-i18next';
import { APP_VERSION } from '@/utils/constants';

/** 00 Pembuka — plum full-bleed while the session restores. */
export const Splash: React.FC = () => {
    const { t } = useTranslation();
    return (
        <div className="relative flex h-dvh flex-col items-center justify-center gap-6 bg-surface-brand text-white">
            <img src="/logo.svg" alt="" draggable={false} className="h-[120px] w-[120px] rounded-[24%] shadow-[0_14px_34px_rgba(0,0,0,.35)] lg:h-40 lg:w-40" />
            <div className="flex flex-col items-center gap-1">
                <span className="text-[34px] font-black tracking-[-0.02em] lg:text-[40px]">{t('app.name')}</span>
                <span className="text-[15px] font-bold text-accent-300">{t('app.tagline')}</span>
            </div>
            <span className="h-8 w-8 rounded-full border-4 border-white/[.18] border-t-accent-500 animate-spin" />
            <span className="absolute bottom-7 text-xs text-primary-200">v{APP_VERSION}</span>
        </div>
    );
};
export default Splash;
